


































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Form } from "../../../interfaces";
import FormCard from "@/components/FormCard.vue";

@Component({
  components: {
    appFormCard: FormCard
  }
})
export default class AV360 extends Vue {
  @Getter("av360Forms", { namespace: "form" }) forms!: Array<Form>;
}
